const API_URL = 'api/'

// APIs de agenda
export const GET_AGENDA_INTERNO = API_URL + 'getAgendainterno' //usuario tipo 1
export const GET_AGENDA_EXTERNO = API_URL + 'getAgendaExterno' //usuario tipo 2
export const GET_AGENDA_COUNT_INTERNO = API_URL + 'getAgendaCountInterno' //usuario tipo 1
export const GET_AGENDA_COUNT_EXTERNO = API_URL + 'getAgendaCountExterno' //usuario tipo 2
export const GET_COFRE_CHAVE = API_URL + 'getcofrechave'
export const SET_COFRE_CHAVE = API_URL + 'setcofrechave'
export const GET_GOOGLE_TOKEN = API_URL + 'getGoogleToken'
export const GOOGLE_REQUEST = API_URL + 'googlerequest'

// APIs de autenticação
export const GET_TOKEN = API_URL + 'auth/token'
export const LOGIN_API = API_URL + 'auth/user'
export const PARAMETROS_API = API_URL + 'parametros'
export const USUARIO_CHANGE_PWD = API_URL + 'usuario/changePwd'

// APIs de BI
export const GET_BI = API_URL + 'getBi'
export const GET_BI_DETAIL = API_URL + 'getBiDetail'
export const SEND_MAIL = API_URL + 'sendMail'

// APIs de dashboards
export const FILE_EXCEL = API_URL + 'getFileExcel'
export const GET_PANEL = API_URL + 'getPanel'
export const GET_GRID = API_URL + 'getGrid'
export const GET_GRID_DETAIL = API_URL + 'getGridDetail'

// APIs de manutenção
export const ATUALIZAR_KIT_DASHBOARD = API_URL + 'atualizarkitdashboard'
export const EXCLUIR_COLECAO = API_URL + 'excluircolecao'
export const EXPORTAR_COLECAO = API_URL + 'exportarcolecao'
export const GET_DEFINICOES = API_URL + 'definicoes'
export const GET_SQLS = API_URL + 'sqls'
export const IMPORTAR_COLECAO = API_URL + 'importarcolecao'
export const IMPORTAR_KIT_PADRAO = API_URL + 'importarkitpadrao'
export const VERIFICAR_KIT_PADRAO = API_URL + 'verificarkitpadrao'

// APIs de preferências
export const GET_PREFERENCIAS = API_URL + 'preferencias/dataset'

// APIs de processos
export const GET_DADOS_PROCESSO = API_URL + 'getDadosProcesso'
export const GET_DOC_ARQ3C = API_URL + 'getDocArq3c'
export const GET_PESSOA = API_URL + 'getPessoa'
export const GET_PROCESSO = API_URL + 'getProcesso'

// APIs de provider
export const PROVIDER_API = API_URL + 'provider'